import {PortalStaticContentParamType} from 'Core/ducks/footer';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';

const footerContentAPIUrl = `api/communication/v1/portalStaticContent`;

const getPortalStaticContent = async (params: PortalStaticContentParamType) => {
  const queryParams = new URLSearchParams(params).toString();
  const requestUrl = `${footerContentAPIUrl}?${queryParams}`;

  const response = await axiosInstance.get(requestUrl, getAxiosConfig());

  return handleResponse(response);
};

export default {
  getPortalStaticContent,
};
